import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useInstantSearch, useCurrentRefinements, Configure } from 'react-instantsearch';
import { InfinitePagination } from '@grandvisionhq/common';
import { useLocation } from '@grandvisionhq/frk-routing';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import { useItemsToClear } from '../Algolia/hooks/use-items-to-clear.js';
import '../types.js';
import '@grandvisionhq/utils';
import 'lodash/orderBy';
import 'classnames';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import 'lodash/uniqBy';
import '@grandvisionhq/iris-ui';
import { useAlgoliaConfig } from '../Algolia/AlgoliaConfig.js';
import 'motion/react';
import 'algoliasearch/lite';
import 'react-dom/server';
import 'lodash/merge';
import '../Algolia/utils/query-string.js';
import { useAlgoliaData } from '../Algolia/hooks/use-algolia-data.js';
import '../Algolia/AlgoliaAnalytics.js';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/products';
import '../CrossSellProducts/utils/create-algolia-filters.js';

const ConnectedInfinitePagination = ({ labelKey  })=>{
    var ref2;
    const isMounted = useIsClient();
    const { searchState , setIndexUiState  } = useAlgoliaData();
    const { results: { nbHits: total  } , status ,  } = useInstantSearch();
    const isLoading = status === 'loading';
    const { getLabel  } = useIntl();
    const { pageSize  } = useAlgoliaConfig();
    const { items  } = useCurrentRefinements();
    const itemsFiltered = useItemsToClear(items);
    const itemsFilteredRef = React.useRef(itemsFiltered);
    var ref1;
    const [length, setLength] = React.useState((ref1 = (ref2 = searchState.configure) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref1 !== void 0 ? ref1 : pageSize);
    const { query  } = useLocation();
    React.useEffect(()=>{
        var ref;
        // In order to not make excessive calls to Algolia, we only want to run this when
        // page > 1. Additionally, we cannot trust page number from Algolia state, as our page
        // number is derived from length and offsets, so we use page querystring for this.
        const page = (ref = Number(query.get('page'))) !== null && ref !== void 0 ? ref : 1;
        if (itemsFiltered.length !== itemsFilteredRef.current.length && page > 1) {
            setIndexUiState((prev)=>swcHelpers.objectSpread({}, prev, {
                    configure: swcHelpers.objectSpread({}, prev.configure, {
                        length: pageSize,
                        offset: 0,
                        page: 1
                    })
                })
            );
            setLength(pageSize);
        }
        itemsFilteredRef.current = itemsFiltered;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemsFiltered
    ]);
    const handleClick = ()=>{
        const newLength = length + pageSize;
        setLength(newLength);
        /**
     * Configure component from algolia does not trigger algolia state changes,
     * so we have to do it ourselves. State change is needed for refinements to be converted
     * to URL query string params.
     */ setIndexUiState((prev)=>swcHelpers.objectSpread({}, prev, {
                configure: swcHelpers.objectSpread({}, prev.configure, {
                    length: newLength
                })
            })
        );
    };
    const currentPage = Math.round(length / pageSize);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isMounted ? /*#__PURE__*/ React.createElement(Configure, {
        offset: 0,
        length: length
    }) : null, /*#__PURE__*/ React.createElement(InfinitePagination, {
        onClick: handleClick,
        buttonLabel: getLabel('search.loadMore'),
        labelKey: labelKey !== null && labelKey !== void 0 ? labelKey : 'search.pagingStatus',
        loaded: length,
        isLoading: isLoading,
        total: total,
        currentPage: currentPage
    }));
};

export { ConnectedInfinitePagination };
//# sourceMappingURL=InfinitePagination.js.map
